module.exports = __webpack_public_path__ + "static/media/instazoom-app-logo-40.edf7800a.png";